import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Component } from 'react';
import Formatter from '../Formatter/Formatter.js';
import { StatoOperazione } from './SnackbarUtils.js';
import DownIcon from '../Icons/DownIcon.js';
import UpIcon from '../Icons/UpIcon.js';
import Badge from '../Badge/Badge.js';
import Progress from '../Progress/Progress.js';
import Table from '../Table/Table.js';
import Button from '../Button/Button.js';
import { FormatterType } from '../Formatter/formatterUtils.js';
import TransitionGroup from '../../node_modules/react-transition-group/esm/TransitionGroup.js';
import CSSTransition from '../../node_modules/react-transition-group/esm/CSSTransition.js';

class DettaglioOperazioneMassiva extends Component {
    constructor(props) {
        super(props);
        this.onErroriExpanded = (e) => {
            e.stopPropagation();
            const { segnaErroriOperazioneChecked, operazione } = this.props;
            this.setState((prevState) => ({
                showErrors: !prevState.showErrors,
            }), () => {
                segnaErroriOperazioneChecked(operazione.id);
            });
        };
        this.onErroriCollapsed = (e) => {
            e.stopPropagation();
            this.setState((prevState) => ({
                showErrors: !prevState.showErrors,
            }));
        };
        this.handleFeedback = (e) => {
            const { eliminaOperazioneAsync, onFeedback, operazione } = this.props;
            if (eliminaOperazioneAsync) {
                eliminaOperazioneAsync(operazione.id);
            }
            if (onFeedback) {
                onFeedback(e, operazione.id, operazione);
            }
        };
        this.stampaInfo = (operazione) => {
            const { errori } = operazione;
            const { showErrors } = this.state;
            return (jsxs("div", { className: "snackbar__infoWrapper", children: [jsxs("div", { className: "snackbar__timeStamp", children: [jsx(Formatter, { tipo: FormatterType.date, valore: operazione.timeStamp }), "-", jsx(Formatter, { tipo: FormatterType.hour, valore: operazione.timeStamp })] }), operazione.stato === StatoOperazione.COMPLETED && operazione.checked && (jsxs("div", { className: "snackbar__infoResults", children: [operazione.selezionati
                                && (jsxs(Fragment, { children: [jsxs("span", { children: ["Selezionati:", jsx("strong", { children: operazione.selezionati })] }), jsxs("span", { children: ["Elaborati:", jsx("strong", { children: operazione.elaborati })] })] })), !operazione.selezionati && jsx("span", { children: "Completato" })] })), operazione.stato === StatoOperazione.COMPLETED
                        && errori.length > 0
                        && (showErrors
                            ? jsx(UpIcon, { onClick: this.onErroriCollapsed })
                            : jsx(DownIcon, { onClick: this.onErroriExpanded })), operazione.stato === StatoOperazione.COMPLETED
                        && errori.filter((x) => !x.deleted).length > 0
                        && jsx(Badge, { alarm: true, children: operazione.errori.filter((x) => !x.deleted).length }), operazione.stato === StatoOperazione.COMPLETED
                        && (errori.length === 0 || operazione.testoFeedback)
                        && (jsx(Button, { className: "snackBar__okNoErrorBtn", onClick: this.handleFeedback, text: true, children: operazione.testoFeedback || 'OK' })), operazione.stato === StatoOperazione.PENDING && (jsx(Progress, { indeterminate: !operazione.selezionati, percentage: operazione.progresso })), operazione.stato === StatoOperazione.PENDING
                        && errori.length > 0
                        && (showErrors
                            ? jsx(UpIcon, { onClick: this.onErroriCollapsed })
                            : jsx(DownIcon, { onClick: this.onErroriExpanded })), operazione.stato === StatoOperazione.PENDING
                        && errori.length > 0 && jsx(Badge, { alarm: true, children: errori.length }), jsx("div", { className: "clear" })] }));
        };
        // eslint-disable-next-line class-methods-use-this
        this.getErrori = (operazione) => operazione.errori.filter((x) => !x.deleted);
        this.state = {
            showErrors: false,
        };
    }
    render() {
        const { aggiornaStatoErrore, eliminaOperazioneAsync, operazione, } = this.props;
        const { showErrors, } = this.state;
        const errori = this.getErrori(operazione);
        return (jsxs("div", { className: "snackbar__dettaglioOperazioneMassiva", children: [jsx("div", { className: "snackbar__infoContainer", children: this.stampaInfo(operazione) }), jsx(TransitionGroup, { className: "snackbar__containerTabellaErrori", children: showErrors && (jsx(CSSTransition, { component: "div", timeout: 250, classNames: "snackbar__errori", children: jsxs(Table, { className: "snackbar__tabellaErrori", children: [jsx(Table.Head, { children: jsxs("tr", { children: [jsx("th", { style: { width: '90%' }, children: "Errore" }), operazione.stato === StatoOperazione.COMPLETED && (jsx("th", { style: { width: '10%' }, children: jsx(Button, { onClick: () => eliminaOperazioneAsync(operazione.id), text: true, children: "Pulisci" }) }))] }) }), jsx(Table.Body, { children: errori.map((e, i) => ( /* eslint-disable react/no-array-index-key */jsxs("tr", { children: [jsx("td", { children: e.content || e.message }), operazione.stato === StatoOperazione.COMPLETED && (jsxs("td", { className: "snackbar__actions", children: [jsx(Button, { onClick: () => aggiornaStatoErrore(operazione.id, e.id, operazione.stato === StatoOperazione.COMPLETED), text: true, children: "OK" }), e.actions] }))] }, i)) /* eslint-enable */) })] }) })) })] }));
    }
}
DettaglioOperazioneMassiva.defaultProps = {
    aggiornaStatoErrore: null,
    eliminaOperazioneAsync: null,
    onFeedback: null,
    operazione: null,
};

export { DettaglioOperazioneMassiva as default };
